export default __webpack_public_path__ + "static/media/hht2_ep12_timeline_03.6897a556.png";